
























































































import { Prop, Component, Vue, Ref } from "vue-property-decorator";
import EditableTableCell from "../components/coordinate/editable-table-cell.vue";
import { UIModel } from "../UIModel";
import _ from 'lodash';
import { SortOrder } from '@/util/PaginationParameters';
import * as moment from "moment";
import RequestAccessModal from "../components/projectlist/request_access_modal.vue";
import { EPlatform } from "@/model/EPlatform";
import { BackendACCRole } from './../model/backend/BackendACCRole';
import { MetaDataHub } from "@/model/frontend/FrontendSettings";
import { BIM360ProjectService } from "@/model/BIM360ProjectService";
import { ACCProjectProduct } from "@/model/ACCProjectProduct";
import { PostACCProjectUserRequestBody, PostBIM360ProjectUserRequestBody} from './../api/APIRequests';
import { ERegion } from "@/model/ERegion";
import { ModuleItems } from "@/model/backend/BackendBIMProjectRolesJob";
import { DataConnectorCompany } from "@/model/DataConnectorCompany";
@Component({
    components: { 
        EditableTableCell, 
        RequestAccessModal 
    },
})

export default class ProjectAccessApproval extends Vue {
    @Prop({ required: true }) public model!: UIModel;
    public selectedRoles: BackendACCRole[] = [];
    public filteredACCRoles: BackendACCRole[] = [];
    public addingUser = false;
    public fields = ['key', 'access'];
    public accProducts: ACCProjectProduct[] = [];
    public bim360Services: BIM360ProjectService[] = [];
    public defaultCompany: DataConnectorCompany | null = null;
    public accountSetting: MetaDataHub | null = null;

    public async mounted () {

        //Admin user has settings data
        const license = this.model.settings.licenses.find(l => l.contacts.find(c => c.email == this.model.user?.email));

        if(!license) {
          //Sub-admin (users in ccEmails) need to load the setting data
          const settingData = await this.model.getProjectlistSetting(String(this.$route.query.accountID));
          if(settingData) {
            this.accountSetting = MetaDataHub.fromJSON(settingData)            
          }
        }

        if(!license && !this.accountSetting) {
          alert('Access denied. Admin users only.');
          this.$router.push('/');
          return;
        }

        this.loadDefaultRoles();
        this.loadDefaultCompany();
        this.loadDefaultAccProjectProducts();
        this.loadDefaultBim360ProjectServices();
        this.addingUserBySkipApprovalSetting();
    }

    public get roles () {
      const foundMetadata = this.getMetadataForHub(String(this.$route.query.accountID));
      if(foundMetadata?.accProjectRolesList.length) {
        return foundMetadata?.accProjectRolesList
      }
      return [];
    }

    public get companies() {
      const foundMetadata = this.getMetadataForHub(String(this.$route.query.accountID));
      if(foundMetadata?.companies?.length) {
        return [...foundMetadata?.companies].sort((a, b) => a.name.localeCompare(b.name));
      }
      return [];
    }

    public get skipApprovalPage() {
      const foundMetadata = this.getMetadataForHub(String(this.$route.query.accountID));
      return foundMetadata?.skipApprovalPage ?? false;
    }

    public getFilteredRole(value: string) {
			this.filteredACCRoles =this.roles.filter((r) => {
				return r.name
					.toString()
					.toLowerCase()
					.indexOf(value.toLowerCase()) >= 0
			});
			console.log("this.filteredACCRoles: ", this.filteredACCRoles);
		}
    
    public getMetadataForHub(accoundID: string): MetaDataHub | undefined {
      //Admin user
      const projectlistLicenses = this.model?.settings?.licenses.filter(l => l.product_code == process.env.VUE_APP_PROJECT_LIST_PRODUCT_CODE);
      const hubsMetadata = projectlistLicenses.flatMap(l => l.metadata?.hubs);
      const foundMetadata = hubsMetadata.find(h => h?.hubId == `b.${this.$route.query.accountID}`);

      // Sub-admin (in ccEmails)
      if(!foundMetadata && this.accountSetting) {
        return this.accountSetting; 
      }

      console.log("foundMetadata", foundMetadata);
      return foundMetadata;
    }

    public loadDefaultRoles() {
      const foundMetadata = this.getMetadataForHub(String(this.$route.query.accountID));
      if(foundMetadata?.defaultACCProjectRoles)
      {
        this.selectedRoles = [...this.selectedRoles, ...foundMetadata?.defaultACCProjectRoles];
      }
    }

    public loadDefaultCompany() {
      const foundMetadata = this.getMetadataForHub(String(this.$route.query.accountID));
      console.log("loadDefaultCompany: ", foundMetadata?.defaultCompany);
      if(foundMetadata?.defaultCompany)
      {
        this.defaultCompany = foundMetadata?.defaultCompany;
      }
    }

    public loadDefaultAccProjectProducts() {
      const foundMetadata = this.getMetadataForHub(String(this.$route.query.accountID));
      if(foundMetadata?.defaultACCProjectProducts)
      {
        this.accProducts = foundMetadata?.defaultACCProjectProducts.accProjectProducts;
      }
    }

    public loadDefaultBim360ProjectServices() {
      const foundMetadata = this.getMetadataForHub(String(this.$route.query.accountID));
      if(foundMetadata?.defaultBIM360ProjectServices)
      {
        this.bim360Services = foundMetadata?.defaultBIM360ProjectServices.services;
      }
    }

    public isSelectedProjectAdmin(services) {
			return services.find(s => s.name === "project_administration")?.access_level === "admin";
		}

		public handleBIM360ServiceAccessChange(services, row: {name: string, access_level: string}): void {
			if (row.name === "project_administration" && row.access_level === "admin") {
				const docService = services.find(s => s.name === "document_management");
				if (docService) {
					docService.access_level = "admin";
				}
			}
		}

    public async addProjectUser() {
      this.addingUser = true;
      try {
          switch (this.$route.query.platform) {
            case 'acc':
              const input: PostACCProjectUserRequestBody & { accountID: string; projectID: string; }= {
                  accountID: String(this.$route.query.accountID),
                  projectID: String(this.$route.query.projectID),
                  email: String(this.$route.query.userEmail),
                  companyID: this.defaultCompany?.id ? this.defaultCompany?.id : "",
                  roleIds: this.selectedRoles.map(r => r.id),
                  products: this.accProducts.filter(p => p.access != 'none'),
                  region: this.$route.query.region as ERegion,
              }
              const result = await this.model.addAccProjectUser(input);
              console.log(result);
              this.redirectToACCMemberPage(this.$route.query.region as ERegion, String(this.$route.query.projectID));
              return;
            case 'bim360':
              const addBIM360ProjectUserBody: PostBIM360ProjectUserRequestBody & { accountID: string; projectID: string; }= {
                accountID: String(this.$route.query.accountID),
                companyID: this.defaultCompany?.id ? this.defaultCompany?.id : "",
                projectID: String(this.$route.query.projectID),
                email: String(this.$route.query.userEmail),
                industry_roles: this.selectedRoles.map(r => r.id),
                services: this.bim360Services.filter(p => p.access_level != 'none'),
                region: this.$route.query.region as ERegion,
              }
              const bim360ProjectUserResult = await this.model.addBIM360ProjectUser(addBIM360ProjectUserBody);
              console.log(bim360ProjectUserResult)
              this.redirectToBIM360MemberPage(String(this.$route.query.accountID), String(this.$route.query.projectID));
              return;
            default:
              return;
          }
      } catch (err) {
        console.log(err);
        let errorMessage = "Failed to add user. Please ensure that the Access/Access Level is set. If the issue persists, verify whether the user is already part of the project, and confirm that you have the necessary permissions to add project users in ACC/BIM 360.";
        if(typeof err?.response?.data === "string" && err?.response?.data.trim()) {
          errorMessage = err?.response?.data;
        }
        (window as any).vue.$buefy.snackbar.open({
            indefinite: true,
            message: errorMessage,
            actionText: 'OK',
            type: 'is-danger',
            position: "is-bottom-right",
            queue: false,
            onAction: () => {
              if(this.skipApprovalPage) {
                (window as any).vue.$router.push("/");
              }
            }
        });

      } finally {
        this.addingUser = false;
      }
    }

    public redirectToACCMemberPage(region: ERegion, projectID: string) {
      if(projectID) {
        const hostURL = this.getACCHostURL(region);
        const link = `${hostURL}/project-admin/members/projects/${projectID}`;
        if(this.skipApprovalPage)
        {
          window.location.href = link;
          return;
        }
        window.open(link, '_blank');
      }
    }

    public redirectToBIM360MemberPage(accountID: string, projectID: string) {
      if(accountID && projectID) {
        const link = `https://admin.b360.autodesk.com/admin/${accountID}/projects/${projectID}`;
        if(this.skipApprovalPage)
        {
          window.location.href = link;
          return;
        }
        window.open(link, '_blank');
      }
    }

    public async addingUserBySkipApprovalSetting() {
      const foundMetadata = this.getMetadataForHub(String(this.$route.query.accountID));
      console.log("skipApprovalPage: ", foundMetadata?.skipApprovalPage);
      if(foundMetadata?.skipApprovalPage)
      {
        await this.addProjectUser();
      }
    }

    public getACCHostURL(region: ERegion) {
      switch (region) {
        case ERegion.APAC:
          return "https://acc.apac.autodesk.com";
        case ERegion.AUS:
          return "https://acc.aus.autodesk.com";
        case ERegion.EMEA:
          return "https://acc.autodesk.eu";
        default:
          //US
          return "https://acc.autodesk.com";
      }
    }
}
